webpackJsonp([1],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(993);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(977)("7301d78e", content, true);

/***/ }),

/***/ 1004:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.7b0e117.png";

/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/timeout.2801844.png";

/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-wrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [(_vm.typeFlag === 0) ? _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1006),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("登录超时，请重新登录")])]) : _vm._e(), _vm._v(" "), (_vm.typeFlag === 1) ? _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1004),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "operate-wrap"
  }, [_c('p', [_vm._v(_vm._s(_vm.time) + "s后"), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("跳转")]), _vm._v("到首页")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1000)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(987),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  "data-v-74280fe4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 987:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            typeFlag: 1,
            timer: null,
            time: 3
        };
    },

    methods: {
        fnCountDown: function fnCountDown() {
            var _this = this;

            clearInterval(_this.timer);
            _this.timer = setInterval(function () {
                _this.time--;
                if (_this.time <= 0) {
                    clearInterval(_this.timer);
                    _this.$router.push({ path: '/' });
                }
            }, 1000);
        }
    },
    mounted: function mounted() {
        this.fnCountDown();
    },
    created: function created() {
        var _this = this;
        var flag = _this.$route.query.flag;

        if (flag != undefined) {
            _this.typeFlag = parseInt(flag);
        }
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.timer);
    }
});

/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(976)();
// imports


// module
exports.push([module.i, ".error-wrap[data-v-74280fe4]{position:absolute;left:20px;right:20px;bottom:0;top:75px;background:#fff;border:1px solid transparent}.error-wrap .wrapper[data-v-74280fe4]{display:inline-block;transform:translate(-50%,-50%);position:absolute;left:50%;top:50%}.error-wrap .wrapper .img-wrap[data-v-74280fe4]{position:relative}.error-wrap .wrapper .img-wrap .info[data-v-74280fe4]{position:absolute;left:50%;top:46px;font-size:20px;color:#fff;transform:translateX(-30%)}.error-wrap .wrapper .operate-wrap[data-v-74280fe4]{text-align:center;font-size:16px;margin:20px 0}.error-wrap .wrapper .operate-wrap a[data-v-74280fe4]{padding:0 5px;color:#00c;text-decoration:underline}", "", {"version":3,"sources":["/Users/ash/work/data.zsdx.cn/data-center/src/view/common/error.vue"],"names":[],"mappings":"AACA,6BACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,SAAU,AACV,SAAU,AACV,gBAAiB,AACjB,4BAA8B,CAC/B,AACD,sCACE,qBAAsB,AACtB,+BAAiC,AACjC,kBAAmB,AACnB,SAAU,AACV,OAAS,CACV,AACD,gDACE,iBAAmB,CACpB,AACD,sDACE,kBAAmB,AACnB,SAAU,AACV,SAAU,AACV,eAAgB,AAChB,WAAY,AACZ,0BAA4B,CAC7B,AACD,oDACE,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAChB,AACD,sDACE,cAAe,AACf,WAAe,AACf,yBAA2B,CAC5B","file":"error.vue","sourcesContent":["\n.error-wrap[data-v-74280fe4] {\n  position: absolute;\n  left: 20px;\n  right: 20px;\n  bottom: 0;\n  top: 75px;\n  background: #fff;\n  border: 1px solid transparent;\n}\n.error-wrap .wrapper[data-v-74280fe4] {\n  display: inline-block;\n  transform: translate(-50%, -50%);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n}\n.error-wrap .wrapper .img-wrap[data-v-74280fe4] {\n  position: relative;\n}\n.error-wrap .wrapper .img-wrap .info[data-v-74280fe4] {\n  position: absolute;\n  left: 50%;\n  top: 46px;\n  font-size: 20px;\n  color: #fff;\n  transform: translateX(-30%);\n}\n.error-wrap .wrapper .operate-wrap[data-v-74280fe4] {\n  text-align: center;\n  font-size: 16px;\n  margin: 20px 0;\n}\n.error-wrap .wrapper .operate-wrap a[data-v-74280fe4] {\n  padding: 0 5px;\n  color: #0000cc;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/1.4eeaa20883f21f3ef2ec.js